<template>
  <div class="popup-overlay" v-if="isPopupOpen" @click="closePopup">
    <div class="popup-container" @click.stop>
      <button class="close-btn" @click="closePopup">&times;</button>

      <!-- 이미지 갤러리 -->
      <div class="gallery-container">
        <div class="gallery-item prev" @click="selectImage(getPrevIndex())">
          <img :src="images[getPrevIndex()].src" :alt="images[getPrevIndex()].alt">
        </div>

        <div class="gallery-item current">
          <img :src="images[currentIndex].src" :alt="images[currentIndex].alt">
        </div>

        <div class="gallery-item next" @click="selectImage(getNextIndex())">
          <img :src="images[getNextIndex()].src" :alt="images[getNextIndex()].alt">
        </div>
      </div>

      <div class="image-caption" v-if="images[currentIndex].caption">
        {{ images[currentIndex].caption }}
        <p><br>방 호실에 따라 뷰는 다르게 보일 수 있습니다.</p>
      </div>
    </div>
  </div>
</template>

<script>
import image15_1 from '@/assets/15_1.jpg';
import image15_2 from '@/assets/15_2.jpg';
import image15_3 from '@/assets/15_3.jpg';
import image15_4 from '@/assets/15_4.jpg';
import image30_1 from '@/assets/30_1.jpg';
import image30_2 from '@/assets/30_2.jpg';
import image30_3 from '@/assets/30_3.jpg';
import image30_5 from '@/assets/30_5.jpg';
import image30_6 from '@/assets/30_6.jpg';
import image30_7 from '@/assets/30_7.jpg';

export default {
  props: {
    floorType: {
      type: String,
      required: true,
    },
    isPopupOpen: Boolean,
  },
  data() {
    return {
      currentIndex: 0,
      images15: [
        { src: image15_1, alt: '15평 붙박이장', caption: '' },
        { src: image15_2, alt: '15평 내부사진', caption: '' },
        { src: image15_3, alt: '15평 화장실', caption: '' },
        { src: image15_4, alt: '15평 화장실', caption: '' },
      ],
      images30: [
        { src: image30_1, alt: '30평 주방', caption: '' },
        { src: image30_2, alt: '이미지 2', caption: '' },
        { src: image30_3, alt: '이미지 3', caption: '' },
        { src: image30_5, alt: '이미지 3', caption: '' },
        { src: image30_6, alt: '이미지 3', caption: '' },
        { src: image30_7, alt: '이미지 3', caption: '' },
      ],
    };
  },
  computed: {
    images() {
      return this.floorType === '30' ? this.images30 : this.images15;
    },
  },
  methods: {
    closePopup() {
      this.$emit('close'); // 부모에게 팝업 닫기 이벤트 전달
    },
    selectImage(index) {
      this.currentIndex = index;
    },
    getPrevIndex() {
      return (this.currentIndex - 1 + this.images.length) % this.images.length;
    },
    getNextIndex() {
      return (this.currentIndex + 1) % this.images.length;
    },
  },
};
</script>

<style scoped>
/* 팝업 트리거 버튼 스타일 */
.open-popup-btn {
  padding: 10px 20px;
  background-color: #4a6cf7;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
}

.open-popup-btn:hover {
  background-color: #3a5bd9;
}

/* 팝업 오버레이 스타일 */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease;
}

/* 팝업 컨테이너 스타일 */
.popup-container {
  position: relative;
  width: 90%;
  max-width: 1500px;
  background-color: transparent;
  border-radius: 8px;
  padding: 20px;
  animation: scaleIn 0.3s ease;
}

/* 닫기 버튼 스타일 */
.close-btn {
  position: absolute;
  top: -40px;
  right: -10px;
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  color: white;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s;
  z-index: 1010;
}

.close-btn:hover {
  background-color: rgba(255, 255, 255, 0.4);
}

/* 갤러리 컨테이너 스타일 */
.gallery-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 800px;
  perspective: 1500px;
}

/* 갤러리 아이템 공통 스타일 */
.gallery-item {
  position: absolute;
  transition: all 0.5s ease;
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
}

.gallery-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* 현재 이미지 스타일 */
.gallery-item.current {
  width: 60%;
  height: 800px;
  z-index: 3;
  transform: translateX(0) scale(1);
  opacity: 1;
}

/* 이전 이미지 스타일 */
.gallery-item.prev {
  width: 40%;
  height: 800px;
  z-index: 2;
  transform: translateX(-70%) scale(0.8);
  opacity: 0.7;
  filter: brightness(0.7);
}

/* 다음 이미지 스타일 */
.gallery-item.next {
  width: 40%;
  height: 800px;
  z-index: 2;
  transform: translateX(70%) scale(0.8);
  opacity: 0.7;
  filter: brightness(0.7);
}

/* 이미지 인디케이터 스타일 */
.gallery-indicators {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  margin: 0 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.indicator.active {
  background-color: white;
}

/* 이미지 설명 스타일 */
.image-caption {
  color: white;
  text-align: center;
  margin-top: 15px;
  font-size: 16px;
}

/* 애니메이션 */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes scaleIn {
  from { transform: scale(0.9); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

/* 반응형 스타일 */
@media (max-width: 768px) {
  .gallery-item.current {
    width: 80%;
    height: 300px;
  }
  
  .gallery-item.prev,
  .gallery-item.next {
    width: 50%;
    height: 200px;
  }
    /* 갤러리 컨테이너 스타일 */
  .gallery-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 500px;
    perspective: 1000px;
  }
}

@media (max-width: 480px) {
  .gallery-item.current {
    width: 90%;
    height: 250px;
  }
  
  .gallery-item.prev,
  .gallery-item.next {
    width: 60%;
    height: 150px;
  }
    /* 갤러리 컨테이너 스타일 */
  .gallery-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 500px;
    perspective: 1000px;
  }
}
</style>
